import React from 'react';
import PurchaseOrder from '../../components/purchase/PurchaseOrder';

/**
 * Page component for the Purchase Order screen
 * @returns {JSX.Element} Purchase Order page
 */
const PurchaseOrderPage = () => {
  return <PurchaseOrder />;
};

export default PurchaseOrderPage; 